import { useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  BooleanField,
  BulkDeleteWithConfirmButton,
  FunctionField,
  useTranslate,
  useResourceContext,
  RecordContextProvider,
  ChipField,
} from "react-admin";
import BadDebtCheckCashingAddDialog from "../../components/badDebtCheckCashings/create/BadDebtCheckCashingAddDialog";
import BadDebtCheckCashingEditDialog from "../../components/badDebtCheckCashings/edit/BadDebtCheckCashingEditDialog";
import badDebtCheckCashingFilterList from "../../components/badDebtCheckCashings/filter/badDebtCheckCashingFilterList";
import TableListActions from "../../components/tableListActions/TableListActions";
import BadDebtCheckCashingExpandList from "../../components/badDebtCheckCashings/expand/BadDebtCheckCashingExpandList";
import EditBtn from "../../components/editBtn/EditBtn";
import ConfirmBtn from "../../components/confirmBtn/ConfirmBtn";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import PrintContent from "../../components/badDebtCheckCashings/print/PrintContent";
import PrintHandler from "../../components/printHandler/PrintHandler";
import PrintBtn from "../../components/printBtn/PrintBtn";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const BadDebtCheckCashingList = () => {
  const resource = useResourceContext();
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const [resetPrintContent, setResetPrintContent] = useState();
  const [printRecord, setPrintRecord] = useState({}); // initial value wajib object kosong untuk cek key id di dependency useeffect DeliveryNote.js
  const t = useTranslate();
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        title="mine.list_title.bad_debt_check_cashing"
        empty={false}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
            createPermission="create_bad_debt_check_cashing"
          />
        }
        filters={badDebtCheckCashingFilterList(permissions)}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
          expand={<BadDebtCheckCashingExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: "#E7EBF0",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField
            source="bad_debt_installment.giro"
            label="mine.label.check_number"
          />
          <FunctionField
            textAlign="center"
            label="mine.label.type"
            render={(record) => {
              let rec = {};
              if (record.type === 1) {
                rec.type = t("mine.label.cashing");
                rec.color = "primary";
              } else if (record.type === 2) {
                rec.type = t("mine.label.cancel");
                rec.color = "error";
              } else if (record.type === 3) {
                rec.type = t("mine.label.rejected");
                rec.color = "error";
              }
              return (
                <RecordContextProvider value={rec}>
                  <ChipField source="type" color={rec.color} size="small" />
                </RecordContextProvider>
              );
            }}
          />
          <TextField source="note" label="mine.label.note" />
          <BooleanField
            source="approved"
            label="mine.label.approved"
            textAlign="center"
          />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              render={(record) => {
                return !record.approved ? (
                  <>
                    <EditBtn
                      editHandler={handleClickOpenEdit(record.id)}
                      sx={{ mr: 1 }}
                    />
                    <ConfirmBtn
                      title="mine.message.approve"
                      content="mine.message.approve_content"
                      label="mine.btn.approve"
                      resource={resource + "/approve"}
                      startIcon={<DoneIcon />}
                    />
                  </>
                ) : (
                  <>                    
                    <PrintBtn
                      dialogProps={{ title: "mine.dialog.print" }}
                      recordId={record.id}
                      setPrintRecord={setPrintRecord}
                      setResetPrintContent={setResetPrintContent}
                    />
                    {permissions?.administrator && (
                      <ConfirmBtn
                        title="mine.message.unapprove"
                        content="mine.message.unapprove_content"
                        label="mine.label.unapprove"
                        resource={resource + "/unapprove"}
                        startIcon={<CloseIcon />}
                        color="error"                        
                      />
                    )}
                  </>
                );
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return (
    <>
      {list}
      <BadDebtCheckCashingAddDialog open={openAdd} setOpen={setOpenAdd} />
      <BadDebtCheckCashingEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
      <PrintHandler
        record={printRecord}
        resetPrintContent={resetPrintContent}
        Content={PrintContent}
      />
    </>
  );
};

export default BadDebtCheckCashingList;
